import React from "react";
import { MyAppliedDutyListPage } from "../../components/employee";
import e from "cors";

export const EmployeeDashboard = React.lazy(() =>
  import("./EmployeeDashboard")
);
export const EmployeeSettings = React.lazy(() => import("./EmployeeSettings"));
export const EmployeeProfileView = React.lazy(() =>
  import("./EmployeeProfileView")
);
export const EmployeeRewards = React.lazy(() => import("./EmployeeRewards"));
export const AssignRewards = React.lazy(() => import("./AssignRewards"));
export const ProcessRewards = React.lazy(() => import("./ProcessRewards"));
export const calendaryear = React.lazy(() => import("./CalendarYear/calendaryear"));
export const EmployeeAppraisal = React.lazy(()=>import("./appraisal/EmployeeAppraisal"));
export const TaskSheetUnlockStatus = React.lazy(()=>import("./TaskSheetUnlockStatus"));
export const EmployeeExcelImport=React.lazy(() => import("./EmployeeExcelImport"));
export const AssetExcelImport=React.lazy(() => import("./AssetExcelImport"));
export const Shifts=React.lazy(() => import("./Shifts"));
export const MyLeave=React.lazy(() => import("./MyLeave"));
export const ApplyMyLeaves=React.lazy(() => import("./ApplyMyLeaves"));
export const MyLeaveList=React.lazy(() => import("./MyLeaveList"));
export const MyProcessLeaveList=React.lazy(() => import("./MyProcessLeaveList"));
export const HolidayCalendarList=React.lazy(() => import("./HolidayCalendarList"));
export const LeaveCalendar=React.lazy(() => import("./LeaveCalendar"));
export const MyAppliedLeaveList=React.lazy(() => import("./MyAppliedLeaveList"));
export const MyLeaveAppliedList=React.lazy(() => import("./MyLeaveAppliedList"));
export const MyDutyAppliedList=React.lazy(() =>import("./MyDutyAppliedList"));
export const LeaveApplicationList=React.lazy(() =>import("./LeaveApplicationList"));
export const DutyApplicationList=React.lazy(() =>import("./DutyApplicationList"));
